<template>
  <div style="position: relative;width: 100%;height: 100%;margin-top:15%;">
    <div :id="id" style="width: 100%;height: 100%;"></div>
  </div>
</template>

<script>
import uuidv1 from "uuid/v1";
import echarts from "echarts";
export default {
  props: {
    value: {
      type: String,
      default: "0"
    },
    rated: {
      type: Number,
      default: 0
    },
    title:{
      type:String,
      default:""
    },
    name:{
      type:String,
      default:""
    },
    unit:{
      type:String,
      default:""
    },
    minMaxValues: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      showTable: false,
      chartId: null,
      charts: null,
      minMaxData:{
          a:0
      }
    };
  },
  computed: {
    id() {
      return this.getId();
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.drawPie(this.chartId);
    });
  },
  watch: {
    value(val) {
      let value = val;
      let aver=parseInt((parseFloat(this.minMaxValues.min) +parseFloat(this.minMaxValues.max))/2)+'';  //平均数
      let min=parseFloat(this.minMaxValues.min) ;
      let max=parseFloat(this.minMaxValues.max); 
      this.charts.setOption({
        series: {
          radius: "100%",
          min: min,
          max: max,
          startAngle: 225, // 仪表盘起始角度,默认 225。圆心 正右手侧为0度，正上方为90度，正左手侧为180度。
          endAngle: -45, // 仪表盘结束角度,默认 -45
          name: "指标值",
          type: "gauge",
          detail: {  
              offsetCenter: [0, '70%'],
              fontSize: 20, // 文字的字体大小,默认 15。
          },
        //   detail: { show: false },
          axisLine: {
            // 坐标轴线
            lineStyle: {
              width: 6,
              // 属性lineStyle控制线条样式
              color: [
                [0.83, "#0097EE"],
                [1, "#0097EE"]
              ]
            }
          },
          //仪表盘小刻度样式
          axisTick: {
            // show: false
          },
          //仪表盘大刻度样式
          splitLine: {
            length: 12,
            lineStyle: {
              color: "auto"
            }
          },
          pointer: {
            width: 2,
            length: "60%",

            itemStyle: {
              // 属性lineStyle控制线条样式
              color: [
                [0.83, "#0097EE"],
                [1, "#0097EE"]
              ]
            }
          },
          title: {
            show: true
          },
          axisLabel: {
                formatter: function (v){
                    min=min+''
                    aver=aver+''
                    max=max+''
                    switch (v + '') {
                        case min : return min;
                        case aver: return aver;
                        case max : return max;
                    }
                }
            },
          data: [{ value: value, name: this.name }]
        }
      });
    },
    minMaxValues:{
      handler(val, oldValue){
          let aver=parseInt((parseFloat(val.min) +parseFloat(val.max))/2)+'';  //平均数
          let min=parseFloat(val.min) ;
          let max=parseFloat(val.max); 
          this.charts.setOption(
              {
                series: {
                    radius: "100%",
                    min,
                    max,
                    startAngle: 225, // 仪表盘起始角度,默认 225。圆心 正右手侧为0度，正上方为90度，正左手侧为180度。
                    endAngle: -45, // 仪表盘结束角度,默认 -45
                    name: "指标值",
                    type: "gauge",
                    detail: { 
                        offsetCenter: [0, '70%'],
                        color: 'auto', // 文字的颜色,默认 auto。
                        // fontSize: 25, // 文字的字体大小,默认 15。
                        fontSize: 20, // 文字的字体大小,默认 15。
                        formatter: '{value}' , // 格式化函数或者字符串
                     },
                    axisLine: {
                        // 坐标轴线
                        lineStyle: {
                        width: 6,
                        // 属性lineStyle控制线条样式
                        color: [
                            [0.83, "#0097EE"],
                            [1, "#0097EE"]
                        ]
                        }
                    },
                    //仪表盘小刻度样式
                    axisTick: {
                        show: false
                    },
                    //仪表盘大刻度样式
                    splitLine: {
                        length: 12,
                        lineStyle: {
                        color: "auto"
                        }
                    },
                    pointer: {
                        width: 2,
                        length: "60%",

                        itemStyle: {
                        // 属性lineStyle控制线条样式
                        color: [
                            [0.83, "#0097EE"],
                            [1, "#0097EE"]
                        ]
                        }
                    },
                    title: {
                        show: true
                    },
                    axisLabel: {
                        formatter: function (v){
                            min=min+''
                            aver=aver+''
                            max=max+''
                            switch (v + '') {
                                case min : return min;
                                case aver: return aver;
                                case max : return max;
                            }
                        }
                    },
                    data: [{ value: this.value, name: this.name }]
                }
            },true
        );
      },
      deep:true
    }
  },
  methods: {
    getId() {
      this.chartId = uuidv1();
      return this.chartId;
    },
    drawPie(id) {
      this.charts = echarts.init(document.getElementById(id));
      this.charts.setOption({
        backgroundColor: "#fff", //rgba设置透明度0.1
        tooltip: {
          formatter: "{a} <br/>{c}" + this.unit,
          confine:true
        },
        grid: {
          left: 0,
          top: 0,
          right: 0,
          bottom: 0
        },
        series: [
          {
            radius: "100%",
            min: this.minMaxValues.min+'',
            max: this.minMaxValues.max+'',
            // startAngle: 225, //开始角度 左侧 
            startAngle: 225, // 仪表盘起始角度,默认 225。圆心 正右手侧为0度，正上方为90度，正左手侧为180度。
            endAngle: -45, // 仪表盘结束角度,默认 -45
            name: this.title,
            type: "gauge",
            detail: { 
                color: 'auto', // 文字的颜色,默认 auto。
                // fontSize: 25, // 文字的字体大小,默认 15。
                fontSize: 16, // 文字的字体大小,默认 15。
                formatter: '{value}' , // 格式化函数或者字符串
                offsetCenter: [0, '70%'],
             },
            axisLine: {
              // 坐标轴线
              lineStyle: {
                width: 6,
                // 属性lineStyle控制线条样式
                color: [
                  [0.8, "#0097EE"],
                  [1, "#0097EE"]
                ]
              }
            },
            //仪表盘小刻度样式
            axisTick: {
              show: false
            },
            //仪表盘大刻度样式
            splitLine: {
              length: 12,
              lineStyle: {
                color: "auto"
              }
            },
            pointer: {
              width: 2,
              length: "60%",

              itemStyle: {
                // 属性lineStyle控制线条样式
                color: [
                  [0.8, "#0097EE"],
                //   [1, "#CF3B13"]
                  [1, "#0097EE"]
                ]
              }
            },
            title: {
              show: true
            },
            axisLabel: {
              show: false
            },

            data: [{ value: this.value == "-" ? 0 : this.value, name: this.title }]
          }
        ]
      });
    }
  }
};
</script>

<style>
</style>